import { getAppEnv } from '../config/env';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const title = 'Make My Trip';

export const meta = [
  {
    charset: 'UTF-8'
  },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, shrink-to-fit=no'
  },
  {
    httpEquiv: 'X-UA-Compatible',
    content: 'IE=edge'
  },
  {
    name: 'description',
    content: 'Boilerplate for React apps with routing & server side rendering'
  }
];

export const link = [
  {
    rel: 'shortcut icon',
    href: `${PUBLIC_URL}/favicon.ico?v1`
  }
];

export const script = [];

export const noscript = [];
